var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoodle7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-10 h-10",
    viewBox: "0 0 69 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03278 52.8131C21.2369 42.8951 37.5408 30.93 55.3242 23.8507C58.6666 22.5202 61.8253 21.5107 65.3745 21.1413",
    stroke: "currentColor",
    strokeWidth: 2.40851,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74896 71.0228C18.3094 61.3239 33.7476 51.2604 49.7649 42.3159C55.2969 39.2267 60.988 36.1918 67.1175 34.4831",
    stroke: "currentColor",
    strokeWidth: 2.40851,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48685 83.403C22.9611 70.0363 44.2167 56.67 67.2376 46.1422",
    stroke: "currentColor",
    strokeWidth: 2.40851,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9234 2C40.2598 36.1161 35.4971 71.2339 34.0016 106",
    stroke: "currentColor",
    strokeWidth: 2.40851,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7211 7.34874C24.5074 29.1677 23.0639 50.8448 21.9814 72.8558",
    stroke: "currentColor",
    strokeWidth: 2.40851,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodle7);
export default __webpack_public_path__ + "static/media/Doodle7.b16d81cd26b3d05de180f21bb3d7157b.svg";
export { ForwardRef as ReactComponent };